import { parseOptionalDate } from '@/lib/utils'
import { formatDistanceStrict, isBefore, startOfDay, subDays } from 'date-fns'

type QuantityOrderedSortable = {
    quantityOrdered?: number | null
    title?: string | null
    shopifyId?: string
}

export function compareByQuantityOrderedDesc(
    a: QuantityOrderedSortable,
    b: QuantityOrderedSortable,
): number {
    const salesDiff = (b.quantityOrdered ?? 0) - (a.quantityOrdered ?? 0)
    if (salesDiff !== 0) return salesDiff
    const titleDiff = (a.title ?? '').localeCompare(b.title ?? '')
    if (titleDiff !== 0) return titleDiff
    return (a.shopifyId ?? '').localeCompare(b.shopifyId ?? '')
}

export function formatLastOrderedLabel(
    lastOrderDate: Date | string | null | undefined,
): string {
    const today = startOfDay(new Date())
    const d = parseOptionalDate(lastOrderDate)
    if (!d) return 'No recent orders'
    const thirtyDaysAgo = subDays(today, 30)
    if (isBefore(d, thirtyDaysAgo)) return 'No recent orders'
    return formatDistanceStrict(d, today, { addSuffix: true })
}
